import angular from 'angular';

(function() {
    'use strict';
    var core = angular.module('app.core');

    // Liste des événement broadcastés liés au process d'authentification
    core.constant(
        'AUTH_EVENTS',
        Object.freeze({
            loginSuccess: 'auth-login-success',
            loginFailed: 'auth-login-failed',
            logoutSuccess: 'auth-logout-success',
            //sessionTimeout: 'auth-session-timeout',
            notAuthenticated: 'auth-not-authenticated',
            notAuthorized: 'auth-not-authorized'
        })
    );
})();
